/* template */
<template><div class="submit-rm-container"><div class="navbarBg"><es-navbar title="人证核验" :style="[(navbarStyle)] | transRpxStyle"></es-navbar></div><div class="es-content"><div class="es-submit-verification"><template v-if="(faceVerificaStatus)"><div class="es-loading-box"><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/V4XDon0zUm1644304468042.png" mode="scaleToFill" class="es-sumit-loading"></mpx-image><span class="es-loading-text">人证信息正在审核中</span><span class="es-loading-texts">请耐心等候</span><div class="es-icon-box-loading"><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/K9mLrtOGSQ1642067505569.png" mode="scaleToFill" class="es-icon-loading"></mpx-image></div></div></template><template v-else><div class="es-loading-box"><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/7iQiGAwq3T1644304412865.png" mode="scaleToFill" class="es-sumit-loading_fail"></mpx-image><span class="es-loading-text">人证核验失败，请重试</span><mpx-view @tap="onClickAgain" class="buttonStyle">重新核验</mpx-view><mpx-view @tap="onClickMessage" class="buttonStyleNone" v-if="(!isCxvipVerify)">短信核验</mpx-view></div></template></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m6e3d6e76"}'>
  @import '~@/mixins/stylus/color.styl'
  .submit-rm-container
    display flex
    flex-direction column
  .navbarBg
    background-color $train-color-fff
  .es-witn-verification
    background #ffffff
  .es-content
    flex 1
    background #ffffff
  .es-submit-verification
    display flex
    justify-content center
  .es-sumit-loading
    width 125px
    height 85px
    margin 0 auto
    display block
  .es-sumit-loading_fail
    width 100px
    height 66px
    margin 0 auto
    display block
  .es-loading-box
    padding-top 40px
    position relative
    z-index 999
    background #ffffff
  .es-loading-text
    display block
    text-align center
    font-weight bold
    margin-top 10px
    padding-bottom 5px
  .es-loading-texts
    display block
    text-align center
    font-size 14px
    color $train-color-999
    padding-top 10px
  .es-icon-box-loading
    position relative
  .es-icon-loading
    width 24px
    height 24px
    position absolute
    top 10px
    left 50%
    margin-left -15px
    animation turn 1s linear infinite
  @keyframes turn
    0%
      -webkit-transform rotate(0deg)
    25%
      -webkit-transform rotate(90deg)
    50%
      -webkit-transform rotate(180deg)
    75%
      -webkit-transform rotate(270deg)
    100%
      -webkit-transform rotate(360deg)
  .buttonStyle
    margin-top 24px
    color white
    background #1473FF
    font-size 16px
    border-color #1473FF
    padding 10px 10px
    margin 16px
    text-align center
    border-radius 8px
    width 190px
    // box-shadow 0 1px 2px rgb(0 0 0 / 20%)
  .buttonStyleNone
    margin-top 24px
    color #1473FF
    background #ffffff
    font-size 16px
    border 1px #1473FF solid
    padding 10px 10px
    margin 16px
    text-align center
    border-radius 8px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m6e3d6e76"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./submit-rm.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./submit-rm.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m6e3d6e76"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"component":true},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
